import axios from "axios"

export default {
    async getLogs(dateRange, tab, module, page = 1, limit = 20, searchPhrase = '') {
        const url = `logs/${dateRange}`
        const params = { tab, module, page, limit }
        if (searchPhrase.length) params.searchPhrase = searchPhrase
        return await axios.get(url, { params }).then(({ data }) => data).catch(err => err)
    },
}
